import React, { Component,Fragment } from "react";
import { Modal, Button, Form, Icon, Input, Checkbox } from "antd";
import buttonimage from "../../../style/images/verify btn.png";

export class MobileActivationForm extends Component {
  state = {
    modal2Visible: true
  };

  setModal2Visible(modal2Visible) {
    this.setState({ modal2Visible });
    this.props.history.push('./');
    this.props.disableRegister();
  }
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log("Received values of form: ", values);
      }
    });
  };
  sendmessage() {
    console.log("sending message");
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
          <Fragment>

                <Modal
          title={
            
              <h1 className="loginTitle">Activate Phone</h1>
          }
          centered
          footer={null}
          visible={this.state.modal2Visible}
          onCancel={() => this.setModal2Visible(false)}
        >
          {/* from this poin the login form starts */}

          <p
            style={{
              fontSize: "small",
              textAlign: "center",
              color: "white",
              textAlign:'left'
            }}
          >
            We need your phone verification so we can contact you later on for prize and/or lucky winners.
          </p>
          <Form onSubmit={this.handleSubmit} className="MobileVerification">
            <Form.Item>
              {getFieldDecorator("activationCode", {
                rules: [
                  { required: true, message: "Please input Activation Code" }
                ]
              })(
                <Input
                  style={{ color: "white" }}
                  // prefix={
                  //   <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                  // }
                  placeholder="Activation Code for Mobile Phone"
                />
              )}
            </Form.Item>

            <Form.Item>

              <div className="row">
                <div className="col-xs-2 col-sm-3 ">
                  <span />
                </div>
                <div className="col-xs-7 col sm-7 centered">
                  <Button
                    style={{ color: "transparent", display: "contents" }}
                    type="image"
                    htmlType="submit"
                  >
                    <img
                      className="login-form-button-login center"
                      src={buttonimage}
                    />
                  </Button>
                </div>{" "}
                <div className="col-xs-2 " />
              </div>

              <p
                style={{
                  fontSize: "small",
                  textAlign: "center",
                  paddingTop: "4%",
                  marginBottom: "-4%",
                  color: "white"
                }}
              >
                Haven't received the code?{" "}
                <a  className="underline" onClick={() => this.sendmessage()}>SEND AGAIN</a><br/>
               want to do this later?{" "}
                <a className="underline" onClick={() => this.setModal2Visible(false)}>SKIP THIS STEP</a>
              </p>
            </Form.Item>
          </Form>
          {/* ending point of the login form */}
        </Modal>
          </Fragment>
      
    );
  }
}

export const MobileActivation = Form.create({})(MobileActivationForm);
